import { Alert, Box, Button, Flex, Heading, spacing } from '@apia/theme';
import { FallbackProps } from 'react-error-boundary';
import { useMount } from 'ahooks';
import navigationLocker from '../../classes/navigationLocker';
import { onScreenLockReady } from './dialogs/modals/ScreenLock';
import { ApiaUtil } from '@apia/components';

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: FallbackProps): JSX.Element => {
  try {
    window.top?.dd?.emit('unlockTabs');
  } catch (e) {
    console.error('Cannot unlock tabs');
    console.error(e);
  }

  useMount(() => {
    onScreenLockReady((tools) => tools.releaseScreenLock());
  });

  return (
    <Flex
      sx={{
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Alert
        role="alert"
        sx={{
          flexDirection: 'column',
          m: spacing(7),
          p: spacing(7),
        }}
        {...window.getVariant('alerts.danger')}
      >
        <Heading
          as="h2"
          sx={{
            alignSelf: 'self-start',
            my: 3,
            wordBreak: 'break-all',
            px: 3,
          }}
        >
          Error: {(error as Error).message}
        </Heading>
        <Box sx={{ width: '100%', mb: spacing(7), wordBreak: 'break-all' }}>
          {(error as Error).stack}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing(4),
          }}
        >
          <Button type="button" onClick={resetErrorBoundary}>
            Try Again
          </Button>
          <Button
            type="button"
            onClick={() => {
              if (window.top === window) {
                navigationLocker.unlock();
                window.location.reload();
              } else ApiaUtil.instance.tabs.currentTab.close();
            }}
            {...window.getVariant('secondary')}
          >
            Close
          </Button>
        </Box>
      </Alert>
    </Flex>
  );
};

export default ErrorFallback;
